import { EventStats } from "./types";
import { usd } from "./helpers";

interface EventStatsBarProps {
  stats: EventStats;
  eventName: string;
}

export const EventStatsBar = ({ stats, eventName }: EventStatsBarProps) => (
  <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 mb-6">
    <div className="flex items-center justify-between mb-4">
      <h1 className="text-xl font-bold text-gray-900">Vertical Sales</h1>
      {eventName && (
        <span className="text-sm font-medium text-gray-500">{eventName}</span>
      )}
    </div>
    <div className="grid grid-cols-2 md:grid-cols-6 gap-4">
      <StatCard
        label="Total Gross"
        value={usd(stats.totalGross)}
        color="text-green-700"
      />
      <StatCard
        label="Net Sales"
        value={usd(stats.netSales)}
        color="text-gray-900"
      />
      <StatCard label="Tips" value={usd(stats.tips)} color="text-gray-700" />
      <StatCard label="Tax" value={usd(stats.tax)} color="text-gray-600" />
      <StatCard
        label="Transactions"
        value={String(stats.totalTransactions)}
        color="text-gray-900"
        plain
      />
      <StatCard
        label="Avg Ticket"
        value={usd(stats.avgTicket)}
        color="text-gray-900"
      />
    </div>
  </div>
);

const StatCard = ({
  label,
  value,
  color,
  plain,
}: {
  label: string;
  value: string;
  color: string;
  plain?: boolean;
}) => (
  <div className="flex flex-col">
    <span className="text-xs font-medium text-gray-500 uppercase tracking-wide">
      {label}
    </span>
    <span
      className={`text-lg font-bold ${color} ${plain ? "" : "tabular-nums"}`}
    >
      {value}
    </span>
  </div>
);
